<template>
	<a href="javascript:void(0);" @click="handleClick" style="margin-right: 0">
		{{ isLoggedIn ? getCurrentUser.name : 'Bejelentkezés' }}
		<span class="drop-down" v-show="showDropDown">
			<ul>
				<li v-if="isAdmin || isConsultant" @click="navigate('admin/')">Partneri felület</li>
				<li v-if="isUser" @click="navigate('profil/szerzodeseim')">Szerződéseim</li>
                <li v-if="isUser" @click="navigate('profil/beallitasok')">Beállítások</li>
				<li @click="logout">Kijelentkezés</li>
			</ul>
		</span>
	</a>
</template>

<script>
import { mapActions, mapGetters, mapMutations } from 'vuex';
export default {
    data() {
		return {
			show: false,
		};
	},
	computed: {
		...mapGetters('auth', ['isLoggedIn', 'getCurrentUser', 'isAdmin', 'isConsultant', 'isUser']),
		showDropDown() {
			return this.isLoggedIn && this.show;
		},
	},
	methods: {
		...mapMutations(['showPopup']),
		...mapActions('auth', ['logout']),
		handleClick() {
			if (!this.isLoggedIn) {
				this.showPopup('Login');
			} else {
				this.show = !this.show;
			}
		},
		navigate(route) {
			location.href = `${location.origin}/${route}`;
		},
	},
};
</script>

<style lang="scss" scoped>
.drop-down {
	position: absolute;
	top: 30px;
	right: 0;
	width: 100%;
	display: block;
	max-height: 200px;
	min-width: 150px;
	max-width: 200px;
	background: white;
	border-radius: 5px;
	border: 1px solid #ccc;

	@media only screen and (max-width: 575px) {
		position: relative;
		max-width: 95%;
		margin: 10px auto;
		top: 0;
	}

	ul {
		padding: 0;
		margin: 0;
		list-style-type: none;

		li {
			padding: 10px 15px;

			&:hover {
				background-color: #ccc;

				a {
					color: black;
				}
			}
		}
	}
}
</style>
